module.exports = __webpack_public_path__ + "static/media/tomorrow.f7944d22.png";